'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = require('@arreeba/ristoranti-lib/lib/constants');

var _constants2 = require('../constants');

var _location = require('../helpers/location');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
  configuredItem: null,
  timePickerVisible: false,
  targetRestaurant: null,
  deliveryAddress: null,
  deliveryAddressExtraInfo: null,
  deliveryLocation: null,
  deliveryAddressConfirmed: false,
  deliveryDate: null,
  deliveryTime: null,
  deliveryData: null,
  deliveryAreaId: null,
  deliveryAreaCustomThreshold: null, // order threshold based on delivery area
  deliveryAreaCustomOffset: null, // order time offset based on delivery area
  orderTypeDefault: null,
  orderType: null,
  currentOrder: null,
  reloadedOrder: null,
  creditCardToken: null,
  checkoutFormData: null,
  cart: [],
  extraCosts: {
    isFetching: false,
    delivery: [],
    takeAway: []
  },
  selectedVoucher: _constants2.ORDER_NO_VOUCHER,

  showErrors: false,

  menu: {
    categories: []
  },
  menuIsFetching: false,
  menuCategoriesCollapsed: false,

  isFetching: false,

  newCreditCardFormData: null,
  paymentMethod: null,
  paymentPickerVisible: false,
  unhandledExpectedAmount: null,

  sessionStartedAt: null,

  isAsap: false
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _constants2.LOAD_APP_CONFIGURATION_SUCCESS:
      {
        var _JSON$parse = JSON.parse(action.data.config),
            order = _JSON$parse.order;

        var orderTypes = order.types;
        var orderTypeDefault = orderTypes && orderTypes[0] || null;
        // set default order type
        return _extends({}, state, {
          orderTypeDefault: orderTypeDefault,
          orderType: orderTypeDefault,
          extraCosts: {
            isFetching: false,
            delivery: [],
            takeAway: []
          },
          menuCategoriesCollapsed: order.menuCategoriesInitCollapsed || initialState.menuCategoriesCollapsed
        });
      }

    case _constants2.LOAD_MENU_START:
      return _extends({}, state, {
        menuIsFetching: true
      });

    case _constants2.LOAD_MENU_SUCCESS:
      return _extends({}, state, {
        menuIsFetching: false,
        menu: action.data[0].menu
      });

    case _constants2.LOAD_MENU_FAILURE:
      return _extends({}, state, {
        menuIsFetching: false,
        errors: action.errors
      });

    case _constants2.MENU_CONFIGURE_ITEM:
      return _extends({}, state, {
        configuredItem: action.item
      });

    case _constants2.MENU_CART_ADDITEM:
      var items = Array.isArray(action.item) ? action.item : [action.item];

      return _extends({}, state, {
        cart: [].concat(_toConsumableArray(state.cart)).concat(items.map(function (item) {
          return _extends({
            cart_id: Math.random().toString(16)
          }, item);
        }))
      });

    case _constants2.MENU_CART_RESTORE_FROM_ORDER:
      return _extends({}, state, {
        cart: [].concat(_toConsumableArray(action.cart.map(function (item) {
          return _extends({
            cart_id: Math.random().toString(16)
          }, item);
        })))
      });

    case _constants2.MENU_CART_REMOVEITEM:
      {
        if (action.item.cart_id) {
          var _newCart = state.cart.filter(function (item) {
            return item.cart_id !== action.item.cart_id;
          });
          return _extends({}, state, {
            cart: _newCart
          });
        }

        var newCart = state.cart.filter(function (item) {
          return item.id !== action.item.id;
        });
        return _extends({}, state, {
          cart: newCart
        });
      }

    case _constants2.MENU_CART_RESET:
      {
        return _extends({}, state, {
          cart: []
        });
      }

    case _constants2.MENU_SHOW_ERRORS:
      return _extends({}, state, {
        showErrors: action.bool
      });

    case _constants2.MENU_COLLAPSE_CATEGORIES:
      return _extends({}, state, {
        menuCategoriesCollapsed: true
      });

    case _constants2.MENU_UNCOLLAPSE_CATEGORIES:
      return _extends({}, state, {
        menuCategoriesCollapsed: false
      });

    case _constants2.DELIVERY_ADDRESS_CHECK_START:
      return _extends({}, state, {
        isFetching: true,
        targetRestaurant: null,
        deliveryTime: null,
        deliveryDate: null,
        deliveryAreaCustomThreshold: null
      });

    case _constants2.DELIVERY_ADDRESS_CHECK_SUCCESS:
      if (!action.data) {
        return _extends({}, state, {
          isFetching: false,
          targetRestaurant: null,
          deliveryAreaCustomThreshold: null,
          deliveryAreaCustomOffset: null
        });
      }

      return _extends({}, state, {
        isFetching: false,
        targetRestaurant: action.data.id,
        deliveryAreaId: action.data.targetDeliveryArea.id,
        deliveryAreaCustomThreshold: action.data.targetDeliveryArea.threshold || null,
        deliveryAreaCustomOffset: action.data.targetDeliveryArea.offset || null,
        extraCosts: _extends({}, state.extraCosts, {
          isFetching: false,
          delivery: []
        })
      });

    case _constants2.DELIVERY_ADDRESS_CHECK_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        targetRestaurant: null,
        deliveryAreaCustomThreshold: null,
        deliveryAreaCustomOffset: null
      });

    case _constants2.DELIVERY_ADDRESS_UPDATE_START:
      return _extends({}, state, {
        isFetching: true
      });

    case _constants2.DELIVERY_ADDRESS_UPDATE_SUCCESS:
      return _extends({}, state, {
        deliveryAddress: (0, _location.mergeAddresses)(state.deliveryAddress, action.data.components),
        deliveryLocation: action.data.location,
        isFetching: false
      });

    case _constants2.DELIVERY_UPDATE_ADDRESS_SNUMBER:
      return _extends({}, state, {
        deliveryAddress: _extends({}, state.deliveryAddress, _defineProperty({}, _location.GEO_COMPONENTS.STREET_NUMBER, action.streetNum))
      });

    case _constants2.DELIVERY_UPDATE_EXTRA_INFO:
      return _extends({}, state, {
        deliveryAddressExtraInfo: action.data
      });

    case _constants2.DELIVERY_SET_ADDRESS:
      return _extends({}, state, {
        deliveryAddress: action.addressComponents,
        deliveryLocation: action.location,
        targetRestaurant: null,
        deliveryAreaCustomThreshold: null,
        deliveryAreaCustomOffset: null
      });
    case _constants2.DELIVERY_RESET_ADDRESS:
      return _extends({}, state, {
        deliveryAddress: initialState.deliveryAddress,
        deliveryLocation: initialState.deliveryLocation,
        targetRestaurant: initialState.targetRestaurant,
        deliveryAddressConfirmed: initialState.deliveryAddressConfirmed,
        deliveryAddressExtraInfo: initialState.deliveryAddressExtraInfo,
        deliveryAreaCustomThreshold: initialState.deliveryAreaCustomThreshold,
        deliveryAreaCustomOffset: initialState.deliveryAreaCustomOffset
      });

    case _constants2.DELIVERY_CONFIRM_ADDRESS:
      return _extends({}, state, {
        deliveryAddressConfirmed: true
      });

    case _constants2.ORDER_FETCH_EXTRA_COSTS_START:
      return _extends({}, state, {
        extraCosts: _extends({}, state.extraCosts, {
          isFetching: true
        })
      });

    case _constants2.ORDER_FETCH_EXTRA_COSTS_SUCCESS:
      return _extends({}, state, {
        extraCosts: _extends({}, state.extraCosts, {
          isFetching: false,
          // inconsistency among API and clients
          // on how extraCosts type are represented
          delivery: action.data.map(function (c) {
            return _extends({}, c, { type: c.type.toLowerCase() });
          })
        })
      });

    case _constants2.ORDER_FETCH_EXTRA_COSTS_FAILURE:
      return _extends({}, state, {
        extraCosts: _extends({}, state.extraCosts, {
          isFetching: false
        })
      });

    case _constants2.ORDER_RELOAD:
      return _extends({}, state, {
        reloadedOrder: action.order
      });

    case _constants2.PICKER_VISIBLE:
      return _extends({}, state, {
        timePickerVisible: action.bool
      });

    case _constants2.DELIVERY_SET_DATE_TIME:
      return _extends({}, state, {
        deliveryDate: action.deliveryDate,
        deliveryTime: action.deliveryTime,
        sessionStartedAt: Date.now()
      });

    case _constants2.DELIVERY_SET_ORDER_TYPE:
      return _extends({}, state, {
        selectedVoucher: _constants2.ORDER_NO_VOUCHER,
        targetRestaurant: null,
        deliveryAddress: null,
        deliveryDate: null,
        deliveryTime: null,
        deliveryAreaCustomThreshold: null,
        deliveryAreaCustomOffset: null,
        orderType: action.orderType,
        timePickerVisible: false
      });

    case _constants2.TAKEAWAY_SET_RESTAURANT:
      {
        return _extends({}, state, {
          targetRestaurant: action.id
        });
      }

    case _constants2.DELIVERY_SET_ORDER_DATA:
      {
        var _action$data = action.data,
            streetNumber = _action$data.streetNumber,
            street_number = _action$data.street_number,
            data = _objectWithoutProperties(_action$data, ['streetNumber', 'street_number']);

        var deliveryAddress = Object.assign({}, state.deliveryAddress, { street_number: streetNumber || street_number });
        return _extends({}, state, {
          deliveryAddress: deliveryAddress,
          deliveryData: data
        });
      }

    case _constants2.ORDER_SET_CHECKOUT_FORM:
      {
        return _extends({}, state, {
          checkoutFormData: _extends({}, state.checkoutFormData, action.data)
        });
      }

    case _constants2.CREATE_CARD_TOKEN_START:
      return _extends({}, state, {
        isFetching: true
      });

    case _constants2.CREATE_CARD_TOKEN_SUCCESS:
      return _extends({}, state, {
        isFetching: false,
        creditCardToken: action.data
      });

    case _constants2.CREATE_CARD_TOKEN_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        creditCardToken: null,
        errors: action.errors
      });

    case _constants2.ORDER_TOGGLE_UNHANDLED:
      return _extends({}, state, {
        paymentPickerVisible: action.flag
      });

    case _constants2.ORDER_NEW_CC_SETFORM:
      return _extends({}, state, {
        newCreditCardFormData: action.data
      });

    case _constants2.PAYMENT_SET_METHOD:
      if (action.method === _constants2.PAYMENT_UNHANDLED) {
        return _extends({}, state, {
          paymentMethod: action.method,
          unhandledExpectedAmount: action.amount
        });
      }

      return _extends({}, state, {
        paymentMethod: action.method,
        unhandledExpectedAmount: null
      });

    case _constants2.STORE_ORDER_START:
      return _extends({}, state, {
        isFetching: true
      });

    case _constants2.STORE_ORDER_SUCCESS:
      {
        var targetRestaurant = state.orderType === _constants2.ORDER_TYPE_DELIVERY ? state.targetRestaurant : state.targetRestaurant;

        return _extends({}, state, {
          isFetching: false,
          currentOrder: _extends({}, action.data, {
            targetRestaurant: targetRestaurant,
            deliveryAddress: state.deliveryAddress,
            deliveryLocation: state.deliveryLocation,
            deliveryDate: state.deliveryDate,
            deliveryTime: state.deliveryTime,
            orderType: state.orderType,
            paymentMethod: state.paymentMethod
          })
        });
      }

    case _constants2.UPDATE_CURRENTORDER:
      {
        return _extends({}, state, {
          currentOrder: _extends({}, state.currentOrder, action.order)
        });
      }

    case _constants2.ORDER_RESET:
      {
        var keep = action.keep.reduce(function (acc, item) {
          return _extends({}, acc, _defineProperty({}, item, state[item]));
        }, {});

        return _extends({}, initialState, {
          extraCosts: state.extraCosts,
          orderTypeDefault: state.orderTypeDefault,
          orderType: state.orderTypeDefault
        }, keep);
      }

    case _constants2.STORE_ORDER_FAILURE:
      return _extends({}, state, {
        isFetching: false,
        errors: action.errors
      });

    // hide errors when item modifier modal
    // is closed (aka popped out of nav)
    case _constants2.UPDATE_ROUTE:
      return _extends({}, state, {
        showErrors: false,
        timePickerVisible: false,
        paymentPickerVisible: false
      });

    case _constants2.ORDER_ADD_VOUCHER:
      {
        return _extends({}, state, {
          selectedVoucher: action.voucherID
        });
      }

    case _constants2.ORDER_TOGGLE_ASAP:
      {
        return _extends({}, state, {
          isAsap: action.status
        });
      }

    case _constants.SWITCH_BUNDLE_ID:
      return _extends({}, initialState);
  }

  return state;
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/reducers/order.js
// module id = 197
// module chunks = 0